import React from 'react';
import { withErrorBoundary } from '@wix/da-react-context/pkg/ErrorBoundary/withErrorBoundary';
import { DeviationTypes } from '../../types/deviation';
import { getDeviationType } from '../_helpers';
import JournalFeedCard from './Journal';
import StatusFeedCard from './Status';
import PollFeedCard from './Poll';
import TierFeedCard from './Tier';
import CommissionFeedCard from './Commission';
const FeedCard = (props)=>{
    switch(getDeviationType(props.deviation)){
        case DeviationTypes.COMMISSION:
            return /*#__PURE__*/ React.createElement(CommissionFeedCard, props);
        case DeviationTypes.POLL:
            return /*#__PURE__*/ React.createElement(PollFeedCard, props);
        case DeviationTypes.JOURNAL:
            return /*#__PURE__*/ React.createElement(JournalFeedCard, props);
        case DeviationTypes.STATUS:
            return /*#__PURE__*/ React.createElement(StatusFeedCard, props);
        case DeviationTypes.TIER:
            return /*#__PURE__*/ React.createElement(TierFeedCard, props);
        default:
            return null;
    }
};
FeedCard.displayName = 'FeedCard';
export default withErrorBoundary(FeedCard, 'FeedCard');
